import axios from 'axios';

// Create axios instance with base configuration for API calls
const api = axios.create({
    baseURL: process.env.REACT_APP_SERVER_API,
    headers: {
        'Content-Type': 'application/json',
    },
});

// Add request interceptor for auth token
api.interceptors.request.use((config) => {
    const token = localStorage.getItem('item');
    if (token) {
        config.headers.Authorization = token;
    }
    const currentBranch = localStorage.getItem('currentBranch');
    if (currentBranch) {
        try {
            const branchData = JSON.parse(currentBranch);
            if (branchData?.id) {
                config.headers['X-Current-Branch'] = branchData.id;
            }
        } catch (e) {
            // Invalid JSON in currentBranch
        }
    }
    return config;
});

export default api;

export const updatePatientImagingAttachement = async (fileArray, id) => {
    const requestURL = `${process.env.REACT_APP_SERVER_API}api/post-patient-medical-history/${id}`;
    const params = {
        method: "PUT",
        body: fileArray,
        headers: {
            "Authorization": localStorage.getItem("item"),
        }
    };
    try {
        const res = await fetch(requestURL, params);
        const data = await res.json();
        return data;
    } catch (error) {
        console.log(error, "errrr");
        throw error;
    }
}



export const uploadPatientFiles = async (files,currentBranch, id) => {
    const requestURL = `${process.env.REACT_APP_SERVER_API}api/post-patient-medical-images/${id}`;
    const params = {
        method: "post",
        body: files,
        headers: {
            "Authorization": localStorage.getItem("item"),
            "X-Current-Branch": currentBranch
        }
    };
    try {
        const res = await fetch(requestURL, params);
        const data = await res.json();
        return data;
    } catch (error) {
        console.log(error, "errrr");
        throw error;
    }
}
